export const IDENTIFIER = {
  INPUTTEXT: 'TEXT',
  INPUTEMAIL: 'EMAIL',
  INPUTNUMBER: 'NUMBER',
  CHECKBOX: 'CHECKBOX',
  SELECT: 'SELECT',
  RADIO: 'RADIO',
  MULTISELECT: 'MULTI_SELECT',
  DATEPICKER: 'DATE_PICKER',
  TIMEPICKER: 'TIME_PICKER',
  FILE: 'FILE',
  TEXTAREA: 'TEXTAREA',
  EDITOR: 'EDITOR',
  PHONE: 'PHONE',
  MULTIPLEPHONE: 'MULTIPLEPHONE',
  DROPDOWNWITHDETAILS: 'DROPDOWNWITHDETAILS',
  MULTIPLEEMAIL: 'MULTIPLEEMAIL',
  EXISTINGID: 'EXISTINGID',
  GROUPNUMBER: 'GROUPNUMBER',
  YOUTUBEURLS: 'YOUTUBEURLS',
  PASSWORD: 'password',
};

export const FUNCTION_IDENTIFIER = {
  ON_INIT: 'oninit',
  ON_CHANGE: 'onChange',
};
